.discord-thread-message {
	height: 18px;
	min-width: 0;
	display: flex;
	align-items: center;
	font-size: 0.875rem;
	line-height: 1.125rem;
}

.discord-thread-message .discord-thread-message-avatar {
	margin-right: 8px;
	flex: 0 0 auto;
	width: 16px;
	height: 16px;
	border-radius: 50%;
	user-select: none;
}

.discord-thread-message .discord-thread-message-username {
	flex-shrink: 0;
	font-size: inherit;
	line-height: inherit;
	margin-right: 0.25rem;
	opacity: 0.64;
	color: white;
	display: inline;
	vertical-align: baseline;
	position: relative;
	overflow: hidden;
}

.discord-light-theme .discord-thread-message .discord-thread-message-username {
	color: #060607;
}

.discord-thread-message .discord-application-tag {
	background-color: #5865f2;
	color: #fff;
	font-size: 0.65em;
	margin-right: 5px;
	border-radius: 3px;
	line-height: 100%;
	text-transform: uppercase;
	display: flex;
	align-items: center;
	height: 0.9375rem;
	padding: 0 0.275rem;
	margin-top: 0.075em;
	border-radius: 0.1875rem;
}

.discord-thread-message .discord-application-tag-verified {
	display: inline-block;
	width: 0.9375rem;
	height: 0.9375rem;
	margin-left: -0.25rem;
}

.discord-thread-message .discord-thread-message-content {
	display: flex;
	align-items: baseline;
}

.discord-thread-message .discord-message-edited {
	color: #72767d;
	font-size: 10px;
	margin-left: 5px;
}

.discord-thread-message .discord-thread-message-timestamp {
	color: #72767d;
	flex-shrink: 0;
	margin-left: 8px;
	font-size: 0.875rem;
	line-height: 1.125rem;
}

.discord-light-theme .discord-thread-message .discord-thread-message-timestamp,
.discord-light-theme .discord-thread-message .discord-message-edited {
	color: #747f8d;
}
